import React, { useEffect, useRef } from "react";
import MainScreen from "../MainScreen/MainScreen";
import { height, width } from "@fortawesome/free-solid-svg-icons/fa0";
import { VeersaLogo } from "../../assets";
import Stepper from "../Stepper/Stepper";

const About = () => {
  const hasInsertedRef = useRef(false);
  const subHeading = [
    "My Bio",
    "Who I Am",
    "Profile Info",
    "Dev Diary",
    "Hey There",
  ];
  const experienceTimeline = [
    {
      title: "Senior Software Engineer",
      org: "Veersa Technologies Pvt. Ltd.",
      date: "Jan 2024 – Present",
      points: [
        "Led frontend development for large-scale airline web and mobile applications, contributing to a unified React Native app that improved performance by 30%.",
        "Implemented and maintained an Nx monorepo architecture, enabling efficient code sharing and streamlined development across web and mobile platforms.",
        "Drove frontend best practices through code reviews, CI/CD collaboration, and deployment processes to ensure high-quality, maintainable code.",
        "Delivered reliable frontend solutions for multiple airline products while mentoring interns, leading knowledge transfer sessions, and managing a small development team.",
        "Conducted frontend interviews and played a key role in onboarding and technical upskilling of new team members.",
      ],
    },
    {
      title: "Software Engineer",
      org: "Veersa Technologies Pvt. Ltd.",
      date: "July 2022 – Dec 2023",
      points: [
        "Designed and implemented the initial architecture of a React application, including Redux-Saga workflows, API integration, routing, and build configuration.",
        "Migrated a legacy Blazor dashboard to React, reducing page load times by 20% and significantly improving performance and maintainability.",
        "Developed customer-facing features that reduced support calls by 35% and increased overall product engagement.",
        "Built scalable Angular features using component-based architecture, reactive forms, and SCSS, delivering responsive and reusable UI components.",
        "Collaborated closely with backend and QA teams to ensure smooth integrations, rapid issue resolution, and on-time deliveries.",
        "Independently delivered a React-based client demo with Power BI integration, earning direct recognition from leadership for impact and execution.",
      ],
    },
    {
      title: "Software Engineer Intern",
      org: "Veersa Technologies Pvt. Ltd.",
      date: "Feb 2022 – July 2022",
      points: [
        "Contributed to the development of user-facing features such as goal tracking and appointment scheduling in a fast-paced healthcare application.",
        "Built efficient, user-centric interfaces using ReactJS, JavaScript, Redux, Redux-Saga, and Material UI.",
        "Worked closely with cross-functional teams to meet delivery timelines while adhering to product and business requirements.",
      ],
    },
  ];

  const educationTimeline = [
    {
      title:
        "Bachelor of Technology – Computer Engineering & Information Technology",
      org: "Dr. APJ Abdul Kalam Technical University, Lucknow, India",
      date: "2018 – 2022",
      points: [
        "Completed a comprehensive undergraduate program focused on computer engineering fundamentals, software development, and information technology.",
        "Built a strong foundation in data structures, algorithms, databases, operating systems, and web technologies.",
        "Actively worked on academic projects involving modern frontend technologies and problem-solving methodologies.",
      ],
    },
    {
      title: "Intermediate (Science with Computer Applications)",
      org: "CISCE Board",
      date: "Passed in May 2017",
      points: [
        "Completed intermediate education with a focus on science and computer applications.",
        "Achieved an overall score of 85.00%, demonstrating strong academic performance.",
      ],
    },
    {
      title: "High School",
      org: "CISCE Board",
      date: "Passed in 2015",
      points: [
        "Completed high school education under the CISCE curriculum.",
        "Secured an overall score of 87.00%, reflecting consistent academic excellence.",
      ],
    },
  ];

  return (
    <MainScreen heading={"About Me"} subHeading={subHeading}>
      <div className="aboutWrapper">
        <div className="stepper">
          <h2
            style={{
              color: "white",
              opacity: 0.7,
              textDecoration: "underline",
            }}
          >
            Work Experience
          </h2>

          <Stepper steps={experienceTimeline} />
        </div>
        <div className="stepper">
          <h2
            style={{
              color: "white",
              opacity: 0.7,
              textDecoration: "underline",
            }}
          >
            Education
          </h2>
          <Stepper steps={educationTimeline} />
        </div>
      </div>
    </MainScreen>
  );
};

export default About;
